import { toast } from "react-toastify";

export const toastFn = ({
  title,
  description,
  variant = "info",
}: {
  title: string;
  description: string;
  variant?: "success" | "error" | "info" | "warning";
}) => {
  const content = (
    <div>
      <p style={{ fontSize: "14px", fontWeight: 600 }}>{title}</p>
      {description && <div>{description}</div>}
    </div>
  );
  toast(content, {
    autoClose: 5000,
    position: toast.POSITION.TOP_CENTER,
    pauseOnHover: true,
    type: variant,
    theme: "colored",
  });
};
